// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateFailedModeDropDown = (key, collection) => ({
    collection,
    key,
    property: 'failureMode',
    type: actions.UPDATE_CLAIM_BATTERY_FAILED_MODE
});

export const updateBatteryClaimPartSerialNumber = value => ({
    property: 'failurePartSerialNumber',
    type: actions.UPDATE_CLAIM_BATTERY_PART_SERIAL_NUMBER,
    value
});

export const updateBatteryClaimFailedModeComments = value => ({
    property: 'failureModeComments',
    type: actions.UPDATE_CLAIM_BATTERY_FAILED_MODE_COMMENTS,
    value
});

export const updateBatteryClaimDtacCase = value => ({
    property: 'dtacCase',
    type: actions.UPDATE_CLAIM_BATTERY_DTAC_CASE,
    value
});

export const updateBatteryClaimDtacSolution = value => ({
    property: 'dtacSolution',
    type: actions.UPDATE_CLAIM_BATTERY_DTAC_SOLUTION,
    value
});

export const updateBatteryClaimOperatorsComplaint = value => ({
    property: 'operatorsComplaint',
    type: actions.UPDATE_CLAIM_BATTERY_OPERATORS_COMPLAINT,
    value
});

export const updateBatteryClaimComplaintCause = value => ({
    property: 'causeOfComplaining',
    type: actions.UPDATE_CLAIM_BATTERY_COMPLAINT_CAUSE,
    value
});

export const updateBatteryClaimComplaintCorrection = value => ({
    property: 'howWasComplaintCorrected',
    type: actions.UPDATE_CLAIM_BATTERY_COMPLAINT_CORRECTION,
    value
});

export const updateBatteryClaimOperatorComments = value => ({
    property: 'comments',
    type: actions.UPDATE_CLAIM_BATTERY_OPERATORS_COMMENTS,
    value
});

export const updateBatteryClaimBasisForSettlement = value => ({
    property: 'basisForSettlement',
    type: actions.UPDATE_CLAIM_BATTERY_BASIS_FOR_SETTLEMENT,
    value
});



// WEBPACK FOOTER //
// ./src/claim/battery/action-creators/failure-panel.js